// Plain-object deep merge; arrays always replace.
export function deepMerge<T>(a: T, b: Partial<T>): T {
  if (Array.isArray(a) || Array.isArray(b as any)) return (b as T) ?? a;
  if (a && typeof a === 'object' && b && typeof b === 'object') {
    const out: any = { ...(a as any) };
    for (const k of Object.keys(b as any)) {
      const av = (a as any)[k];
      const bv = (b as any)[k];
      if (bv && typeof bv === 'object' && !Array.isArray(bv) && av && typeof av === 'object' && !Array.isArray(av)) {
        out[k] = deepMerge(av, bv);
      } else {
        out[k] = bv;
      }
    }
    return out;
  }
  return (b as T) ?? a;
}

